import cn from "@/i18n/cn";
import en from "@/i18n/en";
import ja from "@/i18n/ja";
export default { ja, en, cn };
